import React from 'react';
// import './css/CardsPage.css'; //CSS da página

const CardsPage: React.FC = () => {
    const cards = [
        { id: 1, title: 'PAAR', description: 'Relatório Orçamental 2025', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: '/relatorios' },
        { id: 2, title: 'Card 2', description: 'Descrição do Card 2', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card2' },
        { id: 3, title: 'Card 3', description: 'Descrição do Card 3', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card3' },
        { id: 4, title: 'Card 4', description: 'Descrição do Card 4', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card4' },
        { id: 5, title: 'Card 5', description: 'Descrição do Card 5', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card5' },
        { id: 6, title: 'Card 6', description: 'Descrição do Card 6', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card6' },
        // { id: 7, title: 'Card 7', description: 'Descrição do Card 7', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card7' },
        // { id: 8, title: 'Card 8', description: 'Descrição do Card 8', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card8' },
        // { id: 9, title: 'Card 9', description: 'Descrição do Card 9', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card9' },
        // { id: 10, title: 'Card 10', description: 'Descrição do Card 10', image: 'https://www.dropbox.com/s/tclqbz7o4u8e705/ipad-632394_640.jpg?raw=1', link: 'https://example.com/card10' },
    ];
    return (
        <div className="cards-container">
            <h1>Selecione o Relatório</h1>
            <ul className="cards-grid">
                {cards.map(card => (
                    <li key={card.id}>
                        <div className="img-card iCard-style3">
                            <div className="card-content">
                                <div className="card-image">
                                    <span className="card-title">{card.title}</span>
                                    <img src={card.image} alt={card.title} />
                                </div>
                                <div className="card-text">
                                    <p>{card.description}</p>
                                </div>
                            </div>
                            <div className="card-link">
                                <a href={card.link} title="Read Full" target="_blank" rel="noopener noreferrer">
                                    <span>Acessar</span>
                                </a>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CardsPage;